export function normalizeString(s: string): string {
    return (s || '')
        .toLowerCase()
        .replace(/ё/g, 'е')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^0-9a-z\u0400-\u04ff\s]+/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}

export function splitToTokensNormalized(s: string): string[] {
    return normalizeString(s).split(' ').filter(Boolean);
}

function commonPrefixLength(a: string, b: string): number {
    const len = Math.min(a.length, b.length);
    let i = 0;
    while (i < len && a[i] === b[i]) i++;
    return i;
}

export function textMatchesToken(textNorm: string, tokenNorm: string): boolean {
    if (!tokenNorm) return true;
    if (!textNorm) return false;
    if (textNorm.includes(tokenNorm)) return true;
    const words = textNorm.split(' ').filter(Boolean);
    const minPrefix = Math.min(4, tokenNorm.length);
    for (const w of words) {
        if (!w) continue;
        const cpl = commonPrefixLength(w, tokenNorm);
        if (cpl >= minPrefix) return true;
    }
    return false;
}

export function scoreTextForSearch(textNorm: string, tokenNorm: string): number {
    if (!tokenNorm) return 0;
    if (!textNorm) return 0;
    if (textNorm === tokenNorm) return 100;
    if (textNorm.startsWith(tokenNorm)) return 80;
    if (textNorm.includes(` ${tokenNorm}`)) return 60;
    if (textNorm.includes(tokenNorm)) return 40;
    const words = textNorm.split(' ').filter(Boolean);
    const minPrefix = Math.min(4, tokenNorm.length);
    let best = 0;
    for (const w of words) {
        if (!w) continue;
        const cpl = commonPrefixLength(w, tokenNorm);
        if (cpl >= minPrefix) {
            const ratio = tokenNorm.length > 0 ? cpl / tokenNorm.length : 0;
            const score = 20 + Math.round(20 * ratio); // 20-40 баллов за морфологический матч
            if (score > best) best = score;
        }
    }
    return best;
}

export type SearchFieldSet = {
    name?: string;
    description?: string;
    fillerType?: string;
    fabricType?: string;
    category?: string;
};

export function scoreFieldsForSearch(fields: SearchFieldSet, tokens: string[]): number {
    if (!tokens.length) return 0;
    const nameNorm = normalizeString(fields.name ?? '');
    const descNorm = normalizeString(fields.description ?? '');
    const fillerTypeNorm = normalizeString(fields.fillerType ?? '');
    const fabricTypeNorm = normalizeString(fields.fabricType ?? '');
    const catNorm = normalizeString(fields.category ?? '');
    let totalScore = 0;
    for (const token of tokens) {
        if (!token) continue;
        let tokenMatched = false;
        let tokenBestScore = 0;
        let matchedFieldsForToken = 0;
        const fieldsWithWeights: Array<[string, number]> = [
            [nameNorm, 4], // name - максимальный вес
            [descNorm, 3], // описание
            [fillerTypeNorm, 2], // тип наполнителя
            [fabricTypeNorm, 2], // тип ткани
            [catNorm, 1], // категория
        ];
        for (const [fieldText, weight] of fieldsWithWeights) {
            if (!fieldText) continue;
            const s = scoreTextForSearch(fieldText, token);
            if (s > 0) {
                tokenMatched = true;
                matchedFieldsForToken += 1;
                const weighted = s * weight;
                if (weighted > tokenBestScore) tokenBestScore = weighted;
            }
        }
        if (!tokenMatched) {
            // если хотя бы один токен не нашёлся ни в одном поле - товар не подходит
            return 0;
        }
        const multiFieldBonus = matchedFieldsForToken > 1 ? (matchedFieldsForToken - 1) * 25 : 0; // бонус за совпадения в нескольких полях
        totalScore += tokenBestScore + multiFieldBonus;
    }
    return totalScore;
}
